// Line scanner helpers used across normalization stages.
// Example: splitLines("a\\nb") -> ["a", "b"].
import { isWhitespace } from './chars'

// Split text by CRLF/LF without using regex tokenization.
export function splitLines(input: string): string[] {
  const lines: string[] = []
  let current = ''

  // Walk source and flush line buffer on newline boundaries.
  for (let index = 0; index < input.length; index += 1) {
    const char = input[index]
    // Flush one line when scanner sees LF.
    if (char === '\n') {
      lines.push(current)
      current = ''
      continue
    } else if (char === '\r') {
      // Flush one line on CR and skip optional following LF.
      lines.push(current)
      current = ''
      if (input[index + 1] === '\n') {
        index += 1
      } else {
        // Continue when CR is not followed by LF.
      }
      continue
    } else {
      // Keep collecting line text.
    }

    current += char
  }

  lines.push(current)
  // Return split line list including trailing empty line state.
  return lines
}

// Return first non-whitespace index in a line or -1 when no token exists.
export function findFirstNonWhitespaceIndex(line: string): number {
  for (let index = 0; index < line.length; index += 1) {
    if (!isWhitespace(line[index])) {
      return index
    } else {
      // Continue scanning line for first non-whitespace char.
    }
  }

  // Return -1 when line has only whitespace.
  return -1
}
